<!-- Modal Menu-->
<div class="modal fade rtl " id="menuModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel">{{title}}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around">

                <!-- از تاریخ -->

                <ng-container *ngIf="(reportId >= 1 && reportId <= 7) || (reportId >= 18 && reportId <= 19)">

                    <form [formGroup]="formFrom" class="me-3">

                        <label> از تاریخ </label>

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </ng-container>

                <!-- تا تاریخ -->

                <form [formGroup]="formTo">

                    <label>تا تاریخ</label>

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                        [dateFormat]="'jYYYY/jMM/jDD'">

                        <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                    </ng-persian-datepicker>

                </form>

            </div>

            <div class="modal-footer">

                <button type="button" class="btn btn-success" (click)="confirmed.emit(reportId)">

                    تایید

                    <i class="fa fa-angle-double-down"></i>

                </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">

                    بستن

                    <i class="fa fa-close"></i>

                </button>

            </div>

        </div>

    </div>

</div>
